export default {"src":"/_next/static/media/man-waving.mono.9a316b84.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};